var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCameraOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 8.26602L21.9375 10.2812V6.125C21.9375 5.15977 21.1527 4.375 20.1875 4.375H4C3.03477 4.375 2.25 5.15977 2.25 6.125V21.875C2.25 22.8402 3.03477 23.625 4 23.625H20.1875C21.1527 23.625 21.9375 22.8402 21.9375 21.875V17.7188L25.4375 19.734C26.0199 20.0703 26.75 19.6492 26.75 18.9793V9.02344C26.75 8.35078 26.0199 7.92969 25.4375 8.26602ZM19.9688 21.6562H4.21875V6.34375H19.9688V21.6562ZM24.7812 17.0898L21.9375 15.4547V12.548L24.7812 10.9102V17.0898ZM6.1875 9.84375H9.25C9.37031 9.84375 9.46875 9.74531 9.46875 9.625V8.3125C9.46875 8.19219 9.37031 8.09375 9.25 8.09375H6.1875C6.06719 8.09375 5.96875 8.19219 5.96875 8.3125V9.625C5.96875 9.74531 6.06719 9.84375 6.1875 9.84375Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraOutlined);
export default __webpack_public_path__ + "static/media/video-camera-outlined.8e968537c98f1e42367da18964c44925.svg";
export { ForwardRef as ReactComponent };